"use client"

import React, { useEffect, useRef } from 'react';

import markdownStyles from "@/styles/MarkdownRenderer.module.scss";

function PostBody({ htmlContent }) {
  const contentRef = useRef(null);

  useEffect(() => {
    if (contentRef.current) {
      // Get all anchor tags within the ref's current node
      const anchors = contentRef.current.querySelectorAll('a');

      // Add custom attribute to each anchor tag
      anchors.forEach(anchor => {
        anchor.setAttribute('target', '_blank');
      });
    }
  }, [htmlContent]);

  return (
    <div className="max-w-2xl mx-auto">
      <div
        ref={contentRef}
        className={markdownStyles["markdown"]}
        property="schema:articleBody"
        dangerouslySetInnerHTML={{ __html: htmlContent }}
      />
    </div>
  );
}

export default PostBody;
